import React from 'react';
import firebase from 'firebase/compat/app';
import useUserInitializer from './hooks/useUserInitializer';
import { SplashScreen } from '../SplashScreen/SplashScreen';
import { User } from '../api/user';

type UserInitializerProps = {
  children: React.ReactNode;
  authUser: firebase.User;
  setUser: (user: User) => void;
  isAdmin: boolean;
  setHasAgreedToContract: React.Dispatch<React.SetStateAction<boolean>>;
};

const UserInitializer: React.FC<UserInitializerProps> = ({
  children,
  authUser,
  setUser,
  isAdmin,
  setHasAgreedToContract,
}) => {
  const { loading, user } = useUserInitializer(
    authUser,
    setUser,
    isAdmin,
    setHasAgreedToContract,
  );

  if (loading || !user) {
    return <SplashScreen />;
  }
  return <>{children}</>;
};

export default UserInitializer;
